
/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting === true) {
                entry.target.classList.add("fade-in--is-visible");
            } else {
                //entry.target.classList.remove("fade-in--is-visible");
            }
        });
    });
    var items = document.querySelectorAll(".fade-in");
    items.forEach(function (item, index) {
        observer.observe(item, index);
    });
} else {
    document.querySelector("body").classList.add("no-intersection-observer");
}


document.addEventListener('DOMContentLoaded', () => { 
    const reloadButtons = document.querySelectorAll('.product-hero__button');

    reloadButtons.forEach(button => {
        button.addEventListener('click', function () {
            const href = this.getAttribute('data-href');
            if (href) {
                window.location.href = href;
            }
        });
    });
});
